import ContentFirstSnGuide from "@/containers/Content/ContentFirstSnGuide";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const description =
    "장례식 하나도 감당하기 벅찰텐데, 줄초상이라니 정말 안타까운 마음이 들면서 다른 분들을 위해 일목요연하게 경험을 정리해서 업로드하신 걸 보고 정말 대단하다는 생각을 했습니다. 그래서 제가 장례지도사로 일하면서 보고 배운 것들을 공유하면 누군가에게 큰 도움이 될 수도 있다는 생각을 했습니다. 시점에 따라 장례 전, 장례 중, 장례 후로 나누어 총 3편의 글을 연재 할 계획이며, 피할 수 없는 일이라면 미리 잘 알고 대처하시길 바라는 마음에서 글을 시작합니다.";
  return {
    props: {
      pageOgTitle: `장례 준비 가이드 1편 - 장례 전 | 고이 프라임`,
      pageDescription: description,
      pageKeywords: `장례 준비, 장례식 준비, 장례식 절차, 장례식, 장례, 장례지도사, 줄초상`,
      pageOgDescription: description,
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/direct/content/sn/1-hero.png`,
    },
  };
};

export default function SnFirst() {
  return <ContentFirstSnGuide />;
}
